import { FC, createElement } from 'react';
import { helpPages } from 'pro/config/help';
import { useStoreState } from 'base/store';

export type IHelpLoaderProps = Record<string, any> & {
    code: string;
};

export const HelpLoader: FC<IHelpLoaderProps> = ({ code, ...props }) => {
    const { lang } = useStoreState('rootStore')
    const page = helpPages[code];
    if (!page) {
        return null
    }

    // @ts-ignore
    return createElement(page.content[lang] || page.content.en, props)
};
